import { BorderColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const TableActionWrapper = styled.div`
	position: relative;
	cursor: pointer;

	&:hover {
		.icon-wrapper {
			display: none;
		}

		.actions {
			display: flex;
		}
	}
`;

const IconWrapper = styled.div`
	display: block;
`;

const MenuActions = styled.div`
	display: none;
	position: absolute;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	border: 1px solid ${BorderColors.Primary};
	border-radius: ${BorderRadius.MD}px;
	align-items: center;
	height: 28px;
	right: 0;
	top: -14px;
	background-color: white;
	z-index: 99;
`;

const MenuActionWrapper = styled.div`
	position: relative;
`;

const MenuAction = styled.div`
	width: 32px;
	height: 28px;
	border-right: 1px solid ${BorderColors.Primary};
	align-items: center;
	display: flex;
	justify-content: center;

	&:last-of-type {
		border-right: none;
	}
`;

export { TableActionWrapper, IconWrapper, MenuAction, MenuActions, MenuActionWrapper };
